import { render, staticRenderFns } from "./SelectApproachTypes.vue?vue&type=template&id=14595d23"
import script from "./SelectApproachTypes.vue?vue&type=script&lang=js"
export * from "./SelectApproachTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports